import union from "lodash.union";

export const ArrayUtil = { union };
